import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { isNullOrEmptySpace, NO_VALUE_DISPLAY, SINGLE_KEY } from "@ryde/shared";

import { FramerTooltip } from "../../common";
import { useDecorateWithMark } from "../../utils";
import { IRenderColumnTemplate } from "./_core";

export const EntityNameTextCellTemplate: FC<IRenderColumnTemplate> = ({
  id,
  value,
  name,
  formFieldTypeId,
  e2eData,
}) => {
  const { decorateValue } = useDecorateWithMark();
  const { t } = useTranslation();

  const valueTranslated = t("general.ENTITY_PAGE", {
    entity: t(`${value}.${SINGLE_KEY}`),
  });

  const baseValue = valueTranslated ?? value;

  const valueComputed = useMemo(() => {
    return decorateValue(baseValue);
  }, [baseValue, decorateValue]);

  const tooltipContent = useMemo(() => {
    return valueTranslated ?? value;
  }, [valueTranslated, value]);

  return (
    <div
      className="cell_simple"
      data-e2e-id={`${name}_fieldid_${formFieldTypeId}`}
      data-e2e-value={value}
      data-e2e-template={"entity-name-text-cell"}
      data-e2e-custom={e2eData}
      data-e2e-custom-field-id={id}
    >
      <FramerTooltip content={tooltipContent} rtlStrippedBottomLeftPlacement>
        <span>
          {!isNullOrEmptySpace(baseValue) ? valueComputed : NO_VALUE_DISPLAY}
        </span>
      </FramerTooltip>
    </div>
  );
};
